import React, { useState } from 'react';
import { WizardCard } from './fdicChrome';
import api from '../../../services/api';

const TruckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4" aria-hidden="true">
    <path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <circle cx="7" cy="17" r="2" stroke="currentColor" strokeWidth="1.8" />
    <circle cx="17" cy="17" r="2" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

const SearchIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4" aria-hidden="true">
    <circle cx="11" cy="11" r="6" stroke="currentColor" strokeWidth="1.8" />
    <path d="M16 16l4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const Step4TrackingForm = ({ onSuccess }) => {
  const [trackingNumber, setTrackingNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/fintech/verification/tracking', {
        trackingNumber: trackingNumber.trim(),
      });
      onSuccess(res.data);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
        'That tracking number does not match this case. Please check and try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <WizardCard headerIcon={<TruckIcon />} headerLabel="Tracking Case">
      <div className="px-5 py-6 flex flex-col items-center text-center">
        <div className="w-16 h-16 rounded-lg bg-[#0b2740] text-white flex items-center justify-center mb-4">
          <svg viewBox="0 0 24 24" fill="none" className="w-8 h-8" aria-hidden="true">
            <path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
            <circle cx="7" cy="17" r="2" stroke="currentColor" strokeWidth="1.8" />
            <circle cx="17" cy="17" r="2" stroke="currentColor" strokeWidth="1.8" />
          </svg>
        </div>

        <h2 className="font-serif text-[24px] text-[#1a2b3c]">Live Case Tracking</h2>
        <p className="text-[13px] text-gray-500 mt-2">
          Enter your Tracking ID to view real-time progress.
        </p>
      </div>

      <form onSubmit={submit} className="px-5 pb-5">
        <label className="block text-[11px] font-semibold tracking-[0.15em] uppercase text-gray-600 mb-2">
          Tracking / Case Number
        </label>
        <input
          type="text"
          value={trackingNumber}
          onChange={(e) => setTrackingNumber(e.target.value)}
          placeholder="TRK-C01B056BB…"
          required
          className="w-full border border-gray-300 rounded-md px-4 py-3 text-[14px] text-gray-800 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0b2740]/30 focus:border-[#0b2740]"
        />

        {error && <p className="mt-3 text-[13px] text-red-600">{error}</p>}

        <button
          type="submit"
          disabled={loading || !trackingNumber.trim()}
          className="mt-4 w-full bg-[#0b2740] hover:bg-[#12324f] disabled:opacity-60 text-white text-[13px] font-semibold tracking-[0.15em] uppercase py-4 rounded-md inline-flex items-center justify-center gap-2"
        >
          <SearchIcon />
          {loading ? 'Tracking…' : 'Track Your Case'}
        </button>
      </form>
    </WizardCard>
  );
};

export default Step4TrackingForm;